const searchPlaceHolderConstantsEn = {
  searchPlaceHolder: 'Search',
};
export default searchPlaceHolderConstantsEn;
